import { render } from "./404.vue?vue&type=template&id=3a50a3e2"
const script = {}

import exportComponent from "D:\\工作空间\\xx-fds-protal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__